import type { FC } from 'react';
import { useMemo } from 'react';

import { Provider } from '../context';
import { Inner, StyledDialogContent, StyledDialogOverlay } from '../styles';
import type { ModalProps } from '../types';

const ModalShell: FC<ModalProps> = ({ children, opened, title = null, onClose, size = 'default' }) => {
    const contextValue = useMemo(() => ({ onClose }), [onClose]);

    return (
        <StyledDialogOverlay isOpen={opened} onDismiss={onClose}>
            <StyledDialogContent aria-label={typeof title === 'string' ? title : 'Dialog'} size={size}>
                <Provider value={contextValue}>
                    <Inner>{children}</Inner>
                </Provider>
            </StyledDialogContent>
        </StyledDialogOverlay>
    );
};

export default ModalShell;
